/* eslint-disable import/prefer-default-export */
import React from 'react';
import MenuItem from 'Common/Components/ContextMenu/components/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import { saveTemplateFromVulnContext } from 'store/Manage/actions';
import { useIntl } from 'react-intl';
import { SaveTemplateIcon } from 'Screens/Contextualization/Manage/components/ManageTable/components/ContextMenu/components/styled';
import { setShowContextMenu } from 'store/ManageGeneral/actions';
import { selectVulnsSelected } from 'store/ManageGeneral/selectors';

export const SaveAsTemplate = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const vulnsSelected = useSelector(selectVulnsSelected);

  return (
    <MenuItem
      title={ intl.formatMessage({ id: 'manage.cm.saveAsTemplate' }) }
      icon={ <SaveTemplateIcon /> }
      onClick={ () => {
        dispatch(saveTemplateFromVulnContext(vulnsSelected, 'vulnsGeneral'));
        dispatch(setShowContextMenu(false));
      } }
    />
  );
};
